import { render, staticRenderFns } from "./detailsOrdered.vue?vue&type=template&id=ee57a08a&scoped=true"
import script from "./detailsOrdered.vue?vue&type=script&lang=js"
export * from "./detailsOrdered.vue?vue&type=script&lang=js"
import style0 from "./detailsOrdered.vue?vue&type=style&index=0&id=ee57a08a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee57a08a",
  null
  
)

export default component.exports